module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest_list-e6e4570a835412b5fd6e24bd74dc84c5.webp";